import classnames from 'classnames';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { closeWebView } from '@features/Unsubscribe/utils/close-web-view';
import styles from './Happy.module.scss';
export const Happy = (props: TpWizardSteps) => {
  const {
    query
  } = useRouter();
  const {
    origin
  } = query;
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleDone = useCallback(() => {
    trackUnsubscribeEvent('cancel_happy_you_done_tapped');
    closeWebView();
  }, [trackUnsubscribeEvent]);
  return <Container className={styles.container} eventOnMounted="cancel_happy_you_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="Happy" data-sentry-source-file="index.tsx">
      <div className={classnames('double-grow', styles.content)}>
        <SimpleImage src="cancelling-happy.svg" width="220" height="306" alt="cancelling" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
        <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
          We’re happy to have you by our side!
        </Title>

        <p className={styles.description}>
          Your subscription is active, but you can still cancel it anytime. We
          wish you only positive experience with Mimika!
        </p>
      </div>
      {origin === 'app' && <ButtonGroup>
          <UiKitButton fullWidth className={styles.button} onClick={handleDone}>
            Done
          </UiKitButton>
        </ButtonGroup>}
    </Container>;
};